import React from 'react';
import { TabBarIcon } from '@/components/navigation/TabBarIcon';
import { View, Image, StyleSheet, TouchableOpacity } from 'react-native';
import { useRouter, usePathname } from 'expo-router';

export default function Header() {
  const pathName = usePathname();
  const router = useRouter();

  const handleDatePickerLinkPress = async () => {
    router.navigate({
      pathname: '/Datepicker',
    });
  };
  const handleEditionLinkPress = async () => {
    router.navigate({
      pathname: '/Editionpicker',
    });
  };

  return (
    <View style={styles.headerContainer}>
      {(pathName === '/PDFSelector' || pathName === '/PDFArchive') && (
        <>
          <TouchableOpacity onPress={handleEditionLinkPress} style={styles.magButton}>
            <TabBarIcon name={'alert-circle'} color={'#fff'} />
          </TouchableOpacity>
        </>
      )}
      <Image
        source={require('../assets/boyenslogo.png')}
        style={styles.headerImage}
      />
      {(pathName === '/PDFSelector' || pathName === '/PDFArchive') && (
        <TouchableOpacity onPress={handleDatePickerLinkPress} style={styles.dateButton}>
          <TabBarIcon name={'calendar'} color={'#fff'} />
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingHorizontal: 16,
    height: 90,
    backgroundColor: '#069',
  },
  headerImage: {
    width: '40%',
    height: 40,
    resizeMode: 'contain',
  },
  dateButton: {
    padding: 10,
  },
  magButton: {
    padding: 10,
  },
});
